"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerAccount = exports.CUSTOMER_ACCOUNT_PATH = void 0;
require("../scss/customerAccount.scss");
const react_1 = __importStar(require("react"));
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const router_1 = require("@reach/router");
const react_i18next_1 = require("react-i18next");
const CustomerAccountRouter_1 = __importDefault(require("./routers/CustomerAccountRouter"));
const UpdateAccountInformation_1 = require("./sections/updateAccountInformation/UpdateAccountInformation");
const CustomerOrders_1 = require("./sections/orders/CustomerOrders");
const AddressBook_1 = require("./sections/addressBook/AddressBook");
const MyAccount_1 = require("./sections/myAccount/MyAccount");
const MyToolbox_1 = require("./sections/myToolbox/MyToolbox");
const sections_1 = require("../models/sections");
const customerAccountContext_1 = require("../contexts/customerAccountContext");
const constants_1 = require("../constants");
exports.CUSTOMER_ACCOUNT_PATH = "/account";
const CustomerAccount = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = (0, react_1.useState)(false);
    const [mobileSelectedSection, setMobileSelectedSection] = (0, react_1.useState)();
    const [selectedSection, setSelectedSection] = (0, react_1.useState)(sections_1.Sections.MyAccount);
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { user: customerAccountActions } = customerAccountContext.actions;
    const { currentUser } = customerAccountContext;
    const { localizePath } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    let pathname = typeof window !== "undefined" ? window.location.pathname : "";
    (0, react_1.useEffect)(() => {
        setIsMobileMenuOpen(false);
        if (pathname.includes(t("url:my-orders"))) {
            setMobileSelectedSection(t("customerAccount.orders.sectionTitle"));
            setSelectedSection(sections_1.Sections.MyOrders);
        }
        else if (pathname.includes(t("url:address-book"))) {
            setMobileSelectedSection(t("customerAccount.addressBook.sectionTitle"));
            setSelectedSection(sections_1.Sections.AddressBook);
        }
        else if (pathname.includes(t("url:my-toolbox"))) {
            setMobileSelectedSection(t("customerAccount.myToolbox.sectionTitle"));
            setSelectedSection(sections_1.Sections.MyToolbox);
        }
        else if (pathname.includes(t("url:account-info"))) {
            setMobileSelectedSection(t("customerAccount.updateAccountInformation.sectionTitle"));
            setSelectedSection(sections_1.Sections.UpdateAccountInformation);
        }
        else {
            setMobileSelectedSection(t("customerAccount.myAccount.sectionTitle"));
            setSelectedSection(sections_1.Sections.MyAccount);
        }
    }, [pathname]);
    const getPathName = (section) => {
        switch (section) {
            case sections_1.Sections.MyAccount:
                return MyAccount_1.MY_ACCOUNT_PATH;
            case sections_1.Sections.MyOrders:
                return CustomerOrders_1.ORDERS_PATH;
            case sections_1.Sections.AddressBook:
                return AddressBook_1.ADDRESS_BOOK_PATH;
            case sections_1.Sections.UpdateAccountInformation:
                return UpdateAccountInformation_1.UPDATE_ACCOUNT_INFORMATION_PATH;
            case sections_1.Sections.MyToolbox:
                return MyToolbox_1.MY_TOOLBOX_PATH;
            default:
                return "";
        }
    };
    const handleMenuItemClick = (section) => {
        (0, router_1.navigate)(localizePath(`${exports.CUSTOMER_ACCOUNT_PATH}${getPathName(section)}`));
    };
    const signOut = () => {
        customerAccountActions.signOut().then(() => {
            (0, router_1.navigate)(localizePath("/"));
        });
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-page-container" },
        react_1.default.createElement("div", { className: "boutik-customer-account-page-menu" },
            react_1.default.createElement("p", { className: "boutik-customer-account-page-menu-user-name" }, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.firstname) + " " + (currentUser === null || currentUser === void 0 ? void 0 : currentUser.lastname)),
            react_1.default.createElement("div", { className: `boutik-customer-account-page-menu-mobile ${isMobileMenuOpen ? "boutik-customer-account-page-menu-mobile-open" : ""}`, onClick: () => setIsMobileMenuOpen((prev) => !prev) },
                react_1.default.createElement("span", null, mobileSelectedSection),
                react_1.default.createElement("div", { className: "boutik-customer-account-page-menu-mobile-toggle-image" })),
            react_1.default.createElement("ul", { className: isMobileMenuOpen
                    ? "boutik-customer-account-page-menu-items boutik-customer-account-page-menu-items-mobile-menu-open"
                    : "boutik-customer-account-page-menu-items" },
                react_1.default.createElement("li", { className: selectedSection === sections_1.Sections.MyAccount
                        ? "boutik-customer-account-page-menu-item boutik-customer-account-page-menu-item-selected"
                        : "boutik-customer-account-page-menu-item", onClick: () => {
                        handleMenuItemClick(sections_1.Sections.MyAccount);
                    } }, t("customerAccount.myAccount.menuTitle")),
                react_1.default.createElement("li", { className: selectedSection === sections_1.Sections.MyOrders
                        ? "boutik-customer-account-page-menu-item boutik-customer-account-page-menu-item-selected"
                        : "boutik-customer-account-page-menu-item", onClick: () => {
                        handleMenuItemClick(sections_1.Sections.MyOrders);
                    } }, t("customerAccount.orders.menuTitle")),
                react_1.default.createElement("li", { className: selectedSection === sections_1.Sections.AddressBook
                        ? "boutik-customer-account-page-menu-item boutik-customer-account-page-menu-item-selected"
                        : "boutik-customer-account-page-menu-item", onClick: () => {
                        handleMenuItemClick(sections_1.Sections.AddressBook);
                    } }, t("customerAccount.addressBook.menuTitle")),
                react_1.default.createElement("li", { className: selectedSection === sections_1.Sections.UpdateAccountInformation
                        ? "boutik-customer-account-page-menu-item boutik-customer-account-page-menu-item-selected"
                        : "boutik-customer-account-page-menu-item", onClick: () => {
                        handleMenuItemClick(sections_1.Sections.UpdateAccountInformation);
                    } }, t("customerAccount.updateAccountInformation.menuTitle")),
                (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isPro) && (react_1.default.createElement("li", { className: selectedSection === sections_1.Sections.MyToolbox
                        ? "boutik-customer-account-page-menu-item boutik-customer-account-page-menu-item-selected"
                        : "boutik-customer-account-page-menu-item", onClick: () => {
                        handleMenuItemClick(sections_1.Sections.MyToolbox);
                    } }, t("customerAccount.myToolbox.menuTitle"))),
                react_1.default.createElement("li", { className: "boutik-customer-account-page-menu-item boutik-customer-account-page-menu-item-logout-in", onClick: signOut },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faRightFromBracket, className: "boutik-customer-account-page-menu-item-logout-in-logo" }),
                    t("customerAccount.logoutMenuTitle"))),
            react_1.default.createElement("div", { className: "boutik-customer-account-page-menu-item-logout-out", onClick: signOut },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faRightFromBracket, className: "boutik-customer-account-page-menu-item-logout-out-logo" }),
                t("customerAccount.logoutMenuTitle"))),
        react_1.default.createElement("div", { className: "boutik-customer-account-page-section" },
            react_1.default.createElement(CustomerAccountRouter_1.default, null))));
};
exports.CustomerAccount = CustomerAccount;
//# sourceMappingURL=CustomerAccount.js.map